/* eslint-disable react/prop-types */
import { arrayOf, shape, string } from 'prop-types';

import { Box, Flex, Icon, Text } from '@olist/united';

import { optionsItems } from './fixtures';

const SelectedQualificationItems = ({ qualificationProfile }) => {
  const { segments: selectedSegments, unqualified_segments: unqualifiedSegments } =
    qualificationProfile;

  const getSelectedSegmentsLabel = (slug) => {
    return optionsItems
      .filter((itemObject) => Object.prototype.hasOwnProperty.call(itemObject, slug))
      .map((option) => ({
        slug,
        text: option[slug],
      }))
      .shift();
  };

  const filterSelectedSegments = (condition) =>
    selectedSegments.filter(condition).map(getSelectedSegmentsLabel);

  const qualifiedItems = filterSelectedSegments((item) => !unqualifiedSegments.includes(item));
  const unqualifiedItems = filterSelectedSegments((item) => unqualifiedSegments.includes(item));

  const renderSelectedItem = ({ icon, iconColor, item }) => {
    const itemText = item.text.toLowerCase();

    return (
      <Flex alignItems="center" key={item.slug} my={2} data-testid={`${item.slug}-item`}>
        <Icon name={icon} color={iconColor} size={13} data-testid={`${icon}-icon`} />
        <Text fontWeight="semibold" ml={2}>
          {itemText}
        </Text>
      </Flex>
    );
  };

  return (
    <Box mt={3} fontSize={0} data-ref="selected-qualification-items">
      <Box data-ref="qualified-items">
        {qualifiedItems.map((item) =>
          renderSelectedItem({ item, icon: 'success-outline', iconColor: 'green' })
        )}
      </Box>
      <Box data-ref="unqualified-items">
        {unqualifiedItems.map((item) =>
          renderSelectedItem({ item, icon: 'close-outline', iconColor: 'red' })
        )}
      </Box>
    </Box>
  );
};

SelectedQualificationItems.propTypes = {
  qualificationProfile: shape({
    segments: arrayOf(string),
    unqualified_segments: arrayOf(string),
  }).isRequired,
};

export default SelectedQualificationItems;
